<template>
  <div class="nczs">
    <div class="title">综合数据</div>
    <title-bar title="综合数据">
      <a-form-model layout="inline">
        <a-form-model-item label="村名">
          <a-input placeholder="请输入村名进行查询" v-model="queryParam.orgName" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="default" @click="loadData()">搜索</a-button>
        </a-form-model-item>
      </a-form-model>
    </title-bar>
    <a-spin :spinning="loading">
      <a-table rowKey="id" :columns="columns" :data-source="rowData" :pagination="pagination" @change="tableChange">
      </a-table>
    </a-spin>
  </div>
</template>
<script>
import TitleBar from './components/titleBar.vue'
import { SyntheticDataPage } from '@/api/main/AgricultureAttractManager.js'
export default {
  components: {
    TitleBar
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          title: '村名',
          dataIndex: 'orgName',
          align: 'center',
          width: 80
        },
        {
          title: '户数',
          dataIndex: 'familyNumber',
          align: 'center',
          width: 80
        },
        {
          title: '人口',
          dataIndex: 'peopleNumber',
          align: 'center',
          width: 80
        },
        {
          title: '土地总面积(亩)',
          dataIndex: 'totalLandArea',
          align: 'center',
          width: 120
        },
        {
          title: '村庄占地面积(亩)',
          dataIndex: 'orgFloorArea',
          align: 'center',
          width: 90
        },
        {
          title: '耕地面积(亩)',
          dataIndex: 'arableArea',
          align: 'center',
          width: 90
        },
        {
          title: '山岚面积(亩)',
          dataIndex: 'hillArea',
          align: 'center',
          width: 90
        },
        {
          title: '小麦种植面积(亩)',
          dataIndex: 'wheatArea',
          align: 'center',
          width: 90
        },
        {
          title: '玉米种植面积(亩)',
          dataIndex: 'maizeArea',
          align: 'center',
          width: 90
        },
        {
          title: '花生种植面积(亩)',
          dataIndex: 'peanutArea',
          align: 'center',
          width: 90
        },
        {
          title: '地瓜种植面积(亩)',
          dataIndex: 'sweetPotatoArea',
          align: 'center',
          width: 90
        },
        {
          title: '土豆种植面积(亩)',
          dataIndex: 'potatoArea',
          align: 'center',
          width: 90
        },
        {
          title: '果园面积(亩)',
          dataIndex: 'orchardArea',
          align: 'center',
          width: 90
        },
        {
          title: '大棚果蔬面积(亩)',
          dataIndex: 'greenhouseArea',
          align: 'center',
          width: 90
        },
        {
          title: '西洋参种植面积(亩)',
          dataIndex: 'americanGinsengArea',
          align: 'center',
          width: 110
        },
        {
          title: '经济林木种植面积(亩)',
          dataIndex: 'economicForestGinsengArea',
          align: 'center',
          width: 120
        },
        {
          title: '土地流转面积(亩)',
          dataIndex: 'landTransferArea',
          align: 'center',
          width: 90
        },
        {
          title: '滩涂(亩)',
          dataIndex: 'mudflatArea',
          align: 'center',
          width: 90
        },
        {
          title: '虾池(亩)',
          dataIndex: 'shrimpPondArea',
          align: 'center',
          width: 90
        }
      ],
      rowData: [],
      queryParam: {
        orgName: null,
        pageNo: 1,
        pageSize: 20
      },
      pagination: {
        total: 0,
        pageSize: 20
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true
      SyntheticDataPage(this.queryParam)
        .then(res => {
          this.rowData = res.data.pageData.rows
          this.pagination.total = res.data.pageData.totalRows
          this.rowData.push({
            orgName: '合计',
            id: 'hjh',
            ...res.data.sumData[0]
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    tableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style lang="less">
.nczs {
  .title {
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #000;
  }
  .right .ant-form-item label {
    color: #fff !important;
  }
  .ant-empty-normal {
    margin: 140px 0 !important;
  }
  .ant-table-body {
    overflow: auto;
    min-height: 352px !important;

    .ant-table-row-cell-break-word {
      color: #000 !important;
    }
    .ant-table-row:last-child {
      .ant-table-row-cell-break-word {
        font-weight: bold;
      }
    }
  }
  .ant-table-placeholder {
    display: none;
  }
}
</style>
